(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animasy-brush"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('animasy-brush')) {
  customElements.define('animasy-brush', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const photos = Array.from(this.querySelectorAll('[data-photo]'));
      const stage = this.querySelector('.an-stage');
      const showPhoto = (id) => {
        const index = photos.findIndex(el => el.dataset.photo === String(id));
        if (index < 0) return;
        this.photoIndex = index;
        photos.forEach((el, i) => { el.hidden = i !== index; });
        this.querySelectorAll('[data-show-photo]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.showPhoto === String(id))));
        const counter = this.querySelector('[data-gallery-count]');
        if (counter) counter.textContent = photos.length > 1 ? `${index + 1} / ${photos.length}` : '';
        const thumb = this.querySelector('[data-show-photo="' + id + '"]');
        if (thumb) {
          const strip = thumb.parentElement;
          const bounds = thumb.getBoundingClientRect();
          const frame = strip.getBoundingClientRect();
          if (bounds.left < frame.left || bounds.right > frame.right) strip.scrollLeft += bounds.left - frame.left - (frame.width - bounds.width) / 2;
        }
      };
      const movePhoto = (direction) => {
        if (photos.length < 2) return;
        showPhoto(photos[(this.photoIndex + direction + photos.length) % photos.length].dataset.photo);
      };
      const initial = photos.find(el => !el.hidden) || photos[0];
      if (initial) showPhoto(initial.dataset.photo);
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-show-photo]');
        if (thumb) showPhoto(thumb.dataset.showPhoto);
        const arrow = event.target.closest('[data-gallery-direction]');
        if (arrow) movePhoto(Number(arrow.dataset.galleryDirection));
      }, { signal });
      stage?.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        movePhoto(event.key === 'ArrowRight' ? 1 : -1);
      }, { signal });
      if (stage && this.dataset.swipe === 'true') {
        let touch = null;
        stage.addEventListener('touchstart', event => {
          touch = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
        }, { passive: true, signal });
        stage.addEventListener('touchcancel', () => { touch = null; }, { passive: true, signal });
        stage.addEventListener('touchend', event => {
          if (!touch || !event.changedTouches.length) return;
          const dx = event.changedTouches[0].clientX - touch.x;
          const dy = event.changedTouches[0].clientY - touch.y;
          touch = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) movePhoto(dx < 0 ? 1 : -1);
        }, { passive: true, signal });
      }
      this.addEventListener('change', event => {
        const input = event.target;
        if (!input.matches('input[name="id"]')) return;
        showPhoto(input.dataset.photoId);
        this.querySelector('[data-color-name]').textContent = input.dataset.title;
        this.querySelectorAll('[data-price]').forEach(el => { el.textContent = input.dataset.variantPrice; });
        this.querySelectorAll('[data-compare]').forEach(el => { el.textContent = input.dataset.comparePrice; el.hidden = !input.dataset.comparePrice; });
        if (this.dataset.productPage === 'true') {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', input.value);
          history.replaceState({}, '', url.toString());
        }
      }, { signal });
      const mainButton = this.querySelector('.an-add');
      const sticky = this.querySelector('.an-sticky');
      if (mainButton && sticky) {
        this.observer = new IntersectionObserver(entries => {
          const entry = entries[0];
          sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
        this.observer.observe(mainButton);
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.ready = false;
    }
  });
}


if (!customElements.get('animasy-benefits')) {
  customElements.define('animasy-benefits', class extends HTMLElement {
    connectedCallback() {
      if (this.benefitsReady) return;
      const track = this.querySelector('[data-benefits-track]');
      const slides = Array.from(track?.children || []);
      const controls = this.querySelector('[data-benefits-controls]');
      if (!track || slides.length < 2 || !controls) return;
      this.benefitsReady = true;
      this.benefitsController = new AbortController();
      const signal = this.benefitsController.signal;
      const mobile = window.matchMedia('(max-width: 899px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const dots = Array.from(this.querySelectorAll('[data-benefits-position]'));
      const previous = this.querySelector('[data-benefits-direction="-1"]');
      const next = this.querySelector('[data-benefits-direction="1"]');
      const status = this.querySelector('[data-benefits-status]');
      let index = 0;
      const setIndex = value => {
        index = value;
        dots.forEach((dot, position) => {
          if (position === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        previous.disabled = index === 0;
        next.disabled = index === slides.length - 1;
        const label = `${index + 1} / ${slides.length}`;
        if (status.textContent !== label) status.textContent = label;
      };
      const slideOffset = position => slides[position].offsetLeft - slides[0].offsetLeft;
      const synchronize = () => {
        const edge = track.getBoundingClientRect().left;
        let nearest = 0;
        let distance = Infinity;
        slides.forEach((slide, position) => {
          const delta = Math.abs(slide.getBoundingClientRect().left - edge);
          if (delta < distance) { distance = delta; nearest = position; }
        });
        setIndex(nearest);
      };
      const moveTo = position => {
        const target = Math.max(0, Math.min(slides.length - 1, position));
        track.scrollTo({ left: slideOffset(target), behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      };
      controls.hidden = false;
      this.addEventListener('click', event => {
        const dot = event.target.closest('[data-benefits-position]');
        const arrow = event.target.closest('[data-benefits-direction]');
        if (dot) moveTo(Number(dot.dataset.benefitsPosition));
        if (arrow) moveTo(index + Number(arrow.dataset.benefitsDirection));
      }, { signal });
      track.addEventListener('keydown', event => {
        if (!mobile.matches || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') moveTo(0);
        else if (event.key === 'End') moveTo(slides.length - 1);
        else moveTo(index + (event.key === 'ArrowRight' ? 1 : -1));
      }, { signal });
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.benefitsFrame);
        this.benefitsFrame = requestAnimationFrame(synchronize);
      }, { passive: true, signal });
      this.benefitsResizeObserver = new ResizeObserver(() => {
        track.tabIndex = mobile.matches ? 0 : -1;
        const target = mobile.matches ? index : 0;
        track.scrollTo({ left: slideOffset(target), behavior: 'instant' });
        setIndex(target);
      });
      this.benefitsResizeObserver.observe(track);
      setIndex(0);
    }
    disconnectedCallback() {
      this.benefitsController?.abort();
      this.benefitsResizeObserver?.disconnect();
      cancelAnimationFrame(this.benefitsFrame);
      this.benefitsReady = false;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["animasy-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('animasy-reviews')) {
  customElements.define('animasy-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const track = this.querySelector('.ar-track');
      const cards = Array.from(this.querySelectorAll('.ar-card'));
      const previous = this.querySelector('[data-review-direction="-1"]');
      const next = this.querySelector('[data-review-direction="1"]');
      const sync = () => {
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      const move = (direction) => {
        const first = cards[0];
        if (!first) return;
        const amount = first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
        track.scrollBy({ left: amount * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-review-direction]');
        if (button) move(Number(button.dataset.reviewDirection));
      }, { signal });
      track.addEventListener('scroll', sync, { passive: true, signal });
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      }, { signal });
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.ar-card');
        if (card) track.scrollLeft += card.getBoundingClientRect().left - track.getBoundingClientRect().left;
      }, { signal });
      this.observer = new ResizeObserver(sync);
      this.observer.observe(track);
      sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["animasy-ritual"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('animasy-ritual')) {
  customElements.define('animasy-ritual', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.controller = new AbortController();
      const videos = Array.from(this.querySelectorAll('video'));
      const allowAutoplay = this.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) entry.target.pause();
          else if (allowAutoplay && !document.hidden) entry.target.play().catch(() => {});
        });
      }, { threshold: 0.35 });
      videos.forEach(video => this.observer.observe(video));
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) videos.forEach(video => video.pause());
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
